import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { COMPANIES, NAME } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	LastName = "lastName",
	FirstName = "firstName",
	FatherName = "fatherName",
	Phones = "phones",
	Company = "company",
	App = "app",
}

export const translationTablePath = "mainPage.customers.clients.columns.";

export const initialSortMethod = {
	column: ColumnId.LastName,
	type: "asc" as const,
};

const customerSelectTab = makeTable({
	allIds: [
		ColumnId.LastName,
		ColumnId.FirstName,
		ColumnId.FatherName,
		ColumnId.Phones,
		ColumnId.Company,
		ColumnId.App,
	],
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: [
		ColumnId.LastName,
		ColumnId.FirstName,
		ColumnId.FatherName,
		ColumnId.Phones,
		ColumnId.Company,
		ColumnId.App,
	],
	initialSortMethod,
	initialWidths: {
		[ColumnId.LastName]: NAME,
		[ColumnId.FirstName]: NAME,
		[ColumnId.FatherName]: NAME,
		[ColumnId.Phones]: 220,
		[ColumnId.Company]: COMPANIES,
		[ColumnId.App]: 250,
	},
	initialResizable: {
		[ColumnId.LastName]: true,
		[ColumnId.FirstName]: true,
		[ColumnId.FatherName]: true,
		[ColumnId.Phones]: true,
		[ColumnId.Company]: true,
		[ColumnId.App]: true,
	},
	initialSortable: {
		[ColumnId.LastName]: true,
		[ColumnId.FirstName]: true,
		[ColumnId.FatherName]: true,
		[ColumnId.Phones]: true,
		[ColumnId.Company]: true,
		[ColumnId.App]: true,
	},
});

export default customerSelectTab;
